import React, { useEffect, useState } from 'react'
import './TopButton.css'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import { Link } from 'react-scroll'

const TopButton = () => {
  const [topButtonVisible, setTopButtonVisible] = useState(false)

  useEffect(() => {
    // Show the button once the user has scrolled past the hero section
    const scrollFunction = () => {
      setTopButtonVisible(
        document.body.scrollTop > window.innerHeight ||
          document.documentElement.scrollTop > window.innerHeight,
      )
    }
    scrollFunction()
    window.addEventListener('scroll', scrollFunction)
    return () => window.removeEventListener('scroll', scrollFunction)
  }, [])

  return (
    <Link
      activeClass="active"
      to="home"
      spy={true}
      smooth={true}
      duration={500}
    >
      <button
        className={'topButton ' + (topButtonVisible ? 'on' : 'off')}
        title="Go to top"
      >
        <i aria-hidden="true">
          <ArrowUpwardIcon />
        </i>
      </button>
    </Link>
  )
}

export default TopButton
